<template lang="html">
  <v-card
    :key="routeTitle"
    flat
  >
    <page-bar
      :title="routeTitle"
      :context-menu="routeContextMenu"
    />
    <v-layout
      v-if="currentNavItem && currentNavItem.items[0]"
      wrap
    >
      <v-flex
        v-for="(navItem, i) in currentNavItem.items.filter(n => n.show)"
        :key="i"
        class="my-2"
        xs12
        sm6
        md4
        lg3
      >
        <v-card
          tile
          hover
          class="mx-2"
          height="100%"
          :ripple="true"
          @click.native="doNavRoute(navItem)"
        >
          <v-card-title class="subtitle-1 font-weight-medium">
            {{ navItem.title }}
          </v-card-title>
          <v-divider />
          <v-card-text>{{ navItem.description }}</v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-card-text v-else>
      <v-icon>mdi-flower</v-icon>
      We're still growing.  Someday this will be exactly what you're looking for.
    </v-card-text>
  </v-card>
</template>

<script>
import NavRoute from '../mixins/navRoute'

export default {
  name: 'MenuIndex',
  mixins: [NavRoute]
}
</script>
